module.exports = __webpack_public_path__ + "static/media/video-yardnapha-on.951a3f1a.png";